import type { TFunction } from 'i18next';
import { z } from 'zod';

import { AddressSectionSchema } from './AddressSection.validation';
import { AffiliationsSectionSchema } from './AffiliationsSection.validation';
import {
	ContactSectionSchema,
	validateEmailSequence
} from './HcpSchemas/ContactSection.validation';
import { DemographicsSectionSchema } from './HcpSchemas/DemographicsSection.validation';
import { LicensesSectionSchema } from './HcpSchemas/LicensesSection.validation';
import { NameSectionSchema } from './HcpSchemas/NameSection.validation';
import { ProfessionalSectionSchema } from './HcpSchemas/ProfessionalSection.validation';
import { NewEntityCountryIdSchema } from './NewEntityCountryId.validation';

export const HcpDcrSchema = (t: TFunction, allowMultipleEmails = false) => {
	return NameSectionSchema(t)
		.safeExtend(ContactSectionSchema().shape)
		.safeExtend(DemographicsSectionSchema(t).shape)
		.safeExtend(ProfessionalSectionSchema(t).shape)
		.safeExtend(AddressSectionSchema(t).shape)
		.safeExtend(AffiliationsSectionSchema(t).shape)
		.safeExtend(LicensesSectionSchema().shape)
		.safeExtend(NewEntityCountryIdSchema().shape)
		.extend({
			notes: z.string().trim().nullish(),
			isThirdPartyDataConfirmed: z.boolean().nullish()
		})
		.refine(
			data => {
				const hasAddress = data.addresses && data.addresses.length > 0;
				const hasAffiliation = data.parenthcos && data.parenthcos.length > 0;
				return hasAddress || hasAffiliation;
			},
			{
				message: t
					? t('Affiliation or Address required')
					: 'Affiliation or Address required',
				path: ['addresses']
			}
		)
		.superRefine(validateEmailSequence(t, allowMultipleEmails));
};

export type HcpDcrValuesIn = z.input<ReturnType<typeof HcpDcrSchema>>;
export type HcpDcrValuesOut = z.output<ReturnType<typeof HcpDcrSchema>>;
